import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import State from 'store/State.ts';
import { useSelector } from 'react-redux';

export type ImpactModelState = {
    warning?: string;
    exceedsLimit?: number;
};

const initialState: ImpactModelState = {};

const slice = createSlice({
    name: 'impact-model',
    initialState,
    reducers: {
        setError: (state, action: PayloadAction<string | undefined>) => {
            state.warning = action.payload;
        },
        setExceedsLimit: (state, action: PayloadAction<number | undefined>) => {
            state.exceedsLimit = action.payload;
        },
    },
});

export default slice.reducer;

export const actions = slice.actions;

const selectImpactModelState = (state: State) => state.impactModel;
const selectImpactModelWarning = (state: State) =>
    selectImpactModelState(state).warning;
const selectImpactModelExceedsLimit = (state: State) =>
    selectImpactModelState(state).exceedsLimit;

export const useImpactModelWarning = () =>
    useSelector(selectImpactModelWarning);
export const useImpactModelExceedsLimit = () =>
    useSelector(selectImpactModelExceedsLimit);
